import { render, staticRenderFns } from "./detail_inventory.vue?vue&type=template&id=cc294098&scoped=true&"
import script from "./detail_inventory.vue?vue&type=script&lang=js&"
export * from "./detail_inventory.vue?vue&type=script&lang=js&"
import style0 from "./detail_inventory.vue?vue&type=style&index=0&id=cc294098&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc294098",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc294098')) {
      api.createRecord('cc294098', component.options)
    } else {
      api.reload('cc294098', component.options)
    }
    module.hot.accept("./detail_inventory.vue?vue&type=template&id=cc294098&scoped=true&", function () {
      api.rerender('cc294098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/inventory_detail/components/detail_inventory.vue"
export default component.exports